// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9e80157f","453":"117b0875","770":"3cb5ac14","954":"af794746"}[chunkId] + ".chunk.js";
};